import { render, staticRenderFns } from "./prizeSetting.vue?vue&type=template&id=6e6c1161&scoped=true"
import script from "./prizeSetting.vue?vue&type=script&lang=js"
export * from "./prizeSetting.vue?vue&type=script&lang=js"
import style0 from "./prizeSetting.vue?vue&type=style&index=0&id=6e6c1161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c1161",
  null
  
)

export default component.exports